import { FormattedMessage } from 'react-intl'
import * as HeaderNavigationSubMenuStyles from '../../../../styles/foundation/HeaderNavigationSubMenu.css'
import { formattedMessageValues } from '../../../../utils/FormattedMessageValues'
import { HeaderNavigationSubMenuIndexLink } from './ui/HeaderNavigationSubMenuIndexLink'
import { HeaderNavigationSubMenuItem } from './ui/HeaderNavigationSubMenuItem'

type HeaderNavigationSubMenuExampleProps = {
  industryEntity: Queries.Hygraph_GlobalNavigation['industry']
  interviewEntity: Queries.Hygraph_GlobalNavigation['interview']
  caseStudyEntity: Queries.Hygraph_GlobalNavigation['caseStudy']
}

export const HeaderNavigationSubMenuExample = ({
  industryEntity,
  interviewEntity,
  caseStudyEntity,
}: HeaderNavigationSubMenuExampleProps) => {
  return (
    <>
      <div className={HeaderNavigationSubMenuStyles.Separator({ size: 'standard' })}>
        <div className={HeaderNavigationSubMenuStyles.Headline}>
          <FormattedMessage
            id="components.foundation.header.nav.example.industry.headline"
            defaultMessage="導入企業・業界"
            values={{ ...formattedMessageValues }}
          />
          {industryEntity && <HeaderNavigationSubMenuIndexLink href={industryEntity.indexLink} />}
        </div>

        <ul
          className={HeaderNavigationSubMenuStyles.Links({
            type: 'simple',
          })}
        >
          {industryEntity?.linkListing.map((item: Queries.Hygraph_GlobalNavigationStandardItem) => (
            <li key={item.label}>
              <HeaderNavigationSubMenuItem href={item.link} isBlank={item.isBlank} type="simple">
                {item.label}
              </HeaderNavigationSubMenuItem>
            </li>
          ))}
        </ul>
      </div>

      <div className={HeaderNavigationSubMenuStyles.Separator({ size: 'standard' })}>
        <div className={HeaderNavigationSubMenuStyles.Headline}>
          <FormattedMessage
            id="components.foundation.header.nav.example.interview.headline"
            defaultMessage="導入インタビュー"
            values={{ ...formattedMessageValues }}
          />
          {interviewEntity && <HeaderNavigationSubMenuIndexLink href={interviewEntity.indexLink} />}
        </div>

        <ul
          className={HeaderNavigationSubMenuStyles.Links({
            type: 'thumbnail',
          })}
        >
          {interviewEntity?.linkListing.map((item: Queries.Hygraph_GlobalNavigationThumbnailItem) => (
            <li key={item.title}>
              <HeaderNavigationSubMenuItem href={item.link} isBlank={item.isBlank} type="thumbnail">
                <img src={item.thumbnail.url} alt="" className={HeaderNavigationSubMenuStyles.Links_Thumbnail} />
                <div className={HeaderNavigationSubMenuStyles.Links_Caption}>{item.title}</div>
              </HeaderNavigationSubMenuItem>
            </li>
          ))}
        </ul>
      </div>

      <div className={HeaderNavigationSubMenuStyles.Separator({ size: 'standard' })}>
        <div className={HeaderNavigationSubMenuStyles.Headline}>
          <FormattedMessage
            id="components.foundation.header.nav.example.caseStudy.headline"
            defaultMessage="施策事例"
            values={{ ...formattedMessageValues }}
          />
          {caseStudyEntity && <HeaderNavigationSubMenuIndexLink href={caseStudyEntity.indexLink} />}
        </div>

        <ul
          className={HeaderNavigationSubMenuStyles.Links({
            type: 'thumbnail',
          })}
        >
          {caseStudyEntity?.linkListing.map((item: Queries.Hygraph_GlobalNavigationThumbnailItem) => (
            <li key={item.title}>
              <HeaderNavigationSubMenuItem href={item.link} isBlank={item.isBlank} type="thumbnail">
                <img src={item.thumbnail.url} alt="" className={HeaderNavigationSubMenuStyles.Links_Thumbnail} />
                <div className={HeaderNavigationSubMenuStyles.Links_Caption}>{item.title}</div>
              </HeaderNavigationSubMenuItem>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}
